import React from 'react';
import { NavLink } from 'react-router-dom';
import img from '../../../images/404.jpg';

const NotFound = () => {
    return (
        <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center py-20 px-4 sm:px-6 lg:px-8 mt-16">
            <div className="max-w-md w-full text-center">
                <img src={img} alt="404 Not Found" className="w-full h-auto mx-auto rounded-2xl shadow-2xl mb-8 transform hover:scale-105 transition-transform duration-500" />
                <h1 className="text-4xl font-extrabold text-slate-900 mb-4 tracking-tight">Oops! Page Not Found</h1>
                <p className="text-lg text-slate-600 mb-8">It seems we can't find the page you're looking for.</p>
                <NavLink 
                    to="/home" 
                    className="inline-flex items-center justify-center px-8 py-4 border border-transparent text-base font-bold rounded-full text-slate-900 bg-amber-500 hover:bg-amber-400 shadow-lg transform transition hover:-translate-y-1 hover:shadow-xl"
                >
                    <i className="fas fa-home mr-2"></i> Back to <span className="ml-1 font-extrabold text-slate-900">Gypsy</span>Travels
                </NavLink>
            </div>
        </div>
    );
};

export default NotFound;